import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";

// Site Data - SEO
import { seoData } from "./config/siteData";

// Language Context
import { LanguageProvider } from "./context/LanguageContext";

// Components
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Gallery } from "./components/Gallery";
import { About } from "./components/About";
import { Location } from "./components/Location";
import { Attractions } from "./components/Attractions";
import { FAQ } from "./components/FAQ";
import { Contact } from "./components/Contact";
import { InquiryForm } from "./components/InquiryForm";
import { AdminPanel } from "./components/AdminPanel";
import { Footer } from "./components/Footer";

function App() {
  // SEO - Update document title and meta description
  useEffect(() => {
    document.title = seoData.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", seoData.description);
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen" data-testid="app-container">
        {/* Navigation */}
        <Navbar />

        {/* Main Content */}
        <main>
          {/* Hero Section */}
          <Hero />

          {/* Gallery Section */}
          <Gallery />

          {/* About Section */}
          <About />

          {/* Location Section */}
          <Location />

          {/* Attractions Section */}
          <Attractions />

          {/* FAQ Section */}
          <FAQ />

          {/* Contact Section */}
          <Contact />

          {/* Inquiry Form Section */}
          <InquiryForm />

          {/* Admin Panel (Local Testing) */}
          <AdminPanel />
        </main>

        {/* Footer */}
        <Footer />

        {/* Toast Notifications */}
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
